import React, { useState, useMemo, useCallback, useEffect } from "react";
import { darken, lighten } from "polished";
import Sidebar from "../../components/sideBar/sideBar.js";
import Navbar from "../../components/navbar/navbar.js";
import gridSideBar from "../../components/GridSideBar/gridSideBar.js";
import createColumnDefs from "./columnDefs.js";
import localStorage from "local-storage";
import SearchIcon from "@mui/icons-material/Search";

import {
  Grid,
  Typography,
  Pagination,
  TextField,
  MenuItem,
  Button,
} from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import localeTextTr from "../../locale.tr.js";
import Swal from "sweetalert2";
import { cleanupLocalStorage } from "../../utils/localStorage/cleanupLocalStorage.js";
import { createTurkishFilterParams } from "../../utils/agGridTextFilterTr/agGridFilterUtils.js";
import { getNotes } from "../../api/notesApis/getNotes.js";
import { deleteNote } from "../../api/notesApis/deleteNote.js";
import { NoteModal } from "./NoteModal.js"; // Modal bileşenini import edin
import { getTaxPayerListForNotification } from "../../api/taxPayer/getTaxPayerListForNotification/index.js";
import { createWorker } from "../../api/workerApis/createWorker.js";
import { getWorker } from "../../api/workerApis/getWorker.js";
import AddWorkButtonWithModal from "./AddWorkButtonWithModal.js";
import { addNote } from "../../api/notesApis/addNote.js";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import { showLoadingSwal } from "../../components/loadingSwal/index.js";
function NotesPage() {
  const [status, setStatus] = useState(false);
  const [filterCheck, setFilterCheck] = useState({
    createdAt: false,
    updatedAt: false,
    expiresAt: false,
    status: false,
  });

  const [rowData, setRowData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchedValue, setSearchedValue] = useState(null);

  const [isOpen, setIsOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [pageSize, setPageSize] = useState(250);
  const [totalCount, setTotalCount] = useState(0);
  const [taxpayerList, setTaxpayerList] = useState([]);
  const [workerList, setWorkerList] = useState([]);
  // İş türü listesi
  const workStatusOptions = [
    { id: "EXPIRED", title: "Süresi Geçti" },
    { id: "DECLARATION_READY", title: "Beyan Hazır" },
    { id: "IN_PROGRESS", title: "Devam Ediyor" },
    { id: "NOT_DONE", title: "Yapılmadı" },
    { id: "DECLARATION_APPROVED", title: "Beyan Onaylandı" },
    { id: "DONE", title: "Yapıldı" }, //tıklasın görsün
    { id: "CANCELED", title: "İptal Edildi" },
    { id: "POSTPONED", title: "Ertelendi" },
  ];

  const workTypeOptions = [
    { id: "SICIL", title: "Sicil" },
    { id: "SGK", title: "SGK" },
    { id: "VD", title: "Vergi Dairesi" },
    { id: "GELIR", title: "Gelir" },
    { id: "GGECICI", title: "G.Geçici" },
    { id: "KURUMLAR", title: "Kurumlar" },
    { id: "KGECICI", title: "K.Geçici" },
    { id: "EVRAK", title: "Evrak" },
    { id: "DIGER", title: "Diğer" },
  ];

  const handleAddResponsible = async () => {
    const { value: responsibleName } = await Swal.fire({
      title: "Sorumlu Ekle",
      input: "text",
      inputPlaceholder: "Sorumlu adını giriniz",
      showCancelButton: true,
      confirmButtonText: "Ekle",
      cancelButtonText: "İptal",
      inputValidator: (value) => {
        if (!value) {
          return "Bu alan boş bırakılamaz!";
        }
      },
    });

    if (responsibleName) {
      await createWorker(responsibleName)
        .then((resp) => {
          Swal.fire("Başarılı!", "Sorumlu eklendi.", "success");
        })
        .catch((err) => {
          Swal.fire("Hata!", "Sorumlu eklenirken bir hata oluştu.", "error");
        });
    }
  };

  const handleSaveWork = async (newWork) => {
    const MAX_FILE_SIZE = 7 * 1024 * 1024; // 7 MB

    // newWork.files bir dizi mi kontrol et ve her dosyayı tara
    if (newWork?.files && Array.isArray(newWork.files)) {
      for (const file of newWork.files) {
        if (file.size > MAX_FILE_SIZE) {
          Swal.fire(
            "Hata!",
            `"${file.name}" dosyası 7 MB'dan büyük. Lütfen daha küçük bir dosya yükleyin.`,
            "error"
          );
          return; // İşlemi durdur
        }
      }
    }
    await showLoadingSwal();
    await addNote(
      newWork?.title,
      newWork?.description,
      newWork?.files,
      newWork.status,
      newWork.expiresAt,
      newWork.workType,
      newWork.workerId,
      newWork.taxpayerId
    )
      .then((resp) => {
        Swal.fire("Başarılı!", "Iş eklendi.", "success");
        search();
      })
      .catch((error) => {
        Swal.fire("Hata!", "Iş eklenirken bir hata oluştu.", "error");
      });
    // Burada API çağrısı yapabilirsiniz
  };

  useEffect(() => {
    const lastPage = localStorage.get("page");
    const lastPageSize = localStorage.get("pageSize");
    const sideBarOpen = localStorage.get("sidebar");

    if (sideBarOpen === "false") {
      setIsOpen(false);
    } else {
      setIsOpen(true);
    }
    if (lastPage) {
      setCurrentPage(lastPage);
    }
    if (lastPageSize) {
      setPageSize(lastPageSize);
    }
    localStorage.get("scrollPosition");

    search();
    cleanupLocalStorage();
    window.addEventListener("beforeunload", cleanupLocalStorage);
    return () => {
      window.removeEventListener("beforeunload", cleanupLocalStorage);
    };
  }, []);

  useEffect(() => {
    const lastPage = localStorage.get("page");
    const lastPageSize = localStorage.get("pageSize");
    const sideBarOpen = localStorage.get("sidebar");

    if (sideBarOpen === "false") {
      setIsOpen(false);
    } else {
      setIsOpen(true);
    }
    if (lastPage) {
      setCurrentPage(lastPage);
    }
    if (lastPageSize) {
      setPageSize(lastPageSize);
    }
    localStorage.get("scrollPosition");
  }, [currentPage, pageSize]);

  useEffect(() => {
    let timer;
    setTimeout(clearLocalStorage, 10 * 60 * 1000);
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [pageSize, currentPage]);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  // const autoSizeStrategy = useMemo(() => {
  //   return {
  //     type: "fitGridWidth",
  //     defaultMinWidth: 100,
  //     columnLimits: [
  //       {
  //         colId: "country",
  //         minWidth: 900,
  //       },
  //     ],
  //   };
  // }, []);

  function clearLocalStorage() {
    localStorage.clear();
  }

  const search = (text, searchCurrentPage, searchPageSize) => {
    const workStatusOrder = workStatusOptions.map((option) => option.id);
    setLoading(true);
    let filterDate;
    getNotes(
      searchPageSize ? searchPageSize : pageSize,
      searchCurrentPage ? searchCurrentPage : currentPage,
      status,
      filterDate || "",
      text || searchedValue
    )
      .then(async (resp) => {
        let transformedListt = [];
        await getTaxPayerListForNotification(1, 1000, "", "", "").then(
          (resp) => {
            transformedListt = resp?.data?.data.map((item) => ({
              id: item.id,
              title: item.title,
            }));
            setTaxpayerList(transformedListt);
          }
        );
        let workerListt = [];
        await getWorker().then((resp) => {
          workerListt = resp?.data?.workers;
          setWorkerList(resp?.data?.workers);
        });
        let newList = [];
        for await (const note of resp.data.notes) {
          // console.log(taxpayerList,'taxpayerList')
          const workerTitle =
            workerListt.find((worker) => worker.id === note.workerId)?.title ||
            "Bilgi Yok";

          // taxpayerList'teki taxpayerId'ye karşılık gelen title'ı buluyoruz
          const taxpayerTitle =
            transformedListt.find((taxpayer) => taxpayer.id === note.taxpayerId)
              ?.title || "Bilgi Yok";

          // Yeni veriyi oluşturuyoruz, workerTitle ve taxpayerTitle'ı ekliyoruz
          newList.push({
            ...note, // var olan tüm veriyi koruyoruz
            workerTitle, // workerTitle'ı ekliyoruz
            taxpayerTitle, // taxpayerTitle'ı ekliyoruz
          });
        }
        setRowData(newList);
        setTotalPage(resp.data.totalPage);
        setTotalCount(resp.data.totalNotesCount);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        Swal.fire({
          text: err.response.data.message || "Notlar alınırken hata oluştu.",
          icon: "error",
          confirmButtonText: "Tamam",
          customClass: {
            container: ".swal-overlay",
          },
        });
      });
  };
  const [isModalOpen, setIsModalOpen] = useState(false); // Modal açık/kapalı
  const [selectedNote, setSelectedNote] = useState(null); // Seçilen not

  // Modal'ı aç
  const openModal = (note) => {
    setSelectedNote(note);
    setIsModalOpen(true);
  };

  // Modal'ı kapat
  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedNote(null);
  };

  // Silme işlemi
  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Silmek istediğinize emin misiniz?",
      text: "Bu işlem geri alınamaz!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Evet, sil!",
      cancelButtonText: "Hayır, iptal et",
      reverseButtons: true,
    });

    if (!result.isConfirmed) return;

    await deleteNote(id)
      .then(async (resp) => {
        await Swal.fire({
          title: "Başarıyla silindi!",
          text: "Kayıt başarıyla kaldırıldı.",
          icon: "success",
        });
        search();
      })
      .catch(async (err) => {
        await Swal.fire({
          title: "Hata!",
          text: "Silme işlemi sırasında bir hata oluştu.",
          icon: "error",
        });
      });
  };

  const [columnDefs, setColumnDefs] = useState(
    createColumnDefs(
      openModal,
      handleDelete,
      workTypeOptions,
      workStatusOptions
    )
  );

  const detailCellRendererParams = useMemo(() => {
    return {
      detailGridOptions: {
        enableRangeSelection: true,

        defaultColDef: {
          flex: 0.5,
          resizable: true,
          sortable: true,
          floatingFilter: true,
          suppressMenu: false, // Allow menu in detail grid columns
        },
      },
      getDetailRowData: (params) => {
        params.successCallback(params.data.subDetails);
      },
    };
  }, []);
  const defaultColDef = useMemo(
    () => ({
      // minWidth: 100,
      // flex: 1,
      filter: true,
      sortable: true,
      // resizable: true,
      floatingFilter: true,
      filterParams: createTurkishFilterParams(),
    }),
    []
  );

  const onFirstDataRendered = (params) => {
    params.api.getFilterInstance("status", function (filterInstance) {
      filterInstance.setModel({
        values: [
          "EXPIRED",
          "DECLARATION_READY",
          "IN_PROGRESS",
          "NOT_DONE",
          "DECLARATION_APPROVED",
          "CANCELED",
          "POSTPONED",
        ],
      });
      params.api.onFilterChanged();
    });
  };

  const onGridReady = useCallback(
    (params) => {
      // setGridApi(params.api); // gridApi'yi burada ayarlayın
    },
    [rowData]
  );
  // `workStatusOptions`'ı sıralama için kullanacağımız bir map oluşturuyoruz
  const statusOrderMap = workStatusOptions.reduce((acc, option, index) => {
    acc[option.id] = index;
    return acc;
  }, {});

  const rowDataSorted = rowData.sort((a, b) => {
    // `status`'a göre sıralama yapıyoruz
    return statusOrderMap[a.status] - statusOrderMap[b.status];
  });
  return (
    <Grid container>
      <Grid
        item
        sx={{
          flexBasis: isOpen ? "275px" : "95px",
          flexShrink: 0,
          transition: "flex-basis 0.3s ease", // Düzeltilmiş transition
        }}
      >
        <Sidebar status={isOpen} toggleSidebar={toggleSidebar} />
      </Grid>

      <Grid
        item
        sx={{
          flex: 1,
          display: "flex",
          justifyContent: "flex-end",
          flexDirection: "column",
          gap: 1,
          pr: "12px",
        }}
      >
        <Grid item xs={12}>
          <Navbar />
        </Grid>
        <Grid
          item
          md={12}
          sx={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Grid
            className="grid-area"
            sx={{
              mb: 1,
            }}
          >
            <Grid
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 1,
              }}
            >
              <Grid item sx={{ display: "flex", gap: 1 }}>
                <TextField
                  sx={{ backgroundColor: "#ffffff" }}
                  variant="standard"
                  onBlur={(e) => {
                    setSearchedValue(e.target.value);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.target.blur();
                      search(e.target.value);
                    }
                  }}
                  InputProps={{
                    // disableUnderline: true, // Çizgiyi kaldırmak için
                    placeholder: "Ara...", // Placeholder metni
                  }}
                />
                <Button
                  sx={{
                    textTransform: "none",
                    alignItems: "center",
                    gap: 1,

                    backgroundColor: "#00cfe8",
                    "&:hover": {
                      backgroundColor: darken(0.1, "#00cfe8"),
                      borderColor: "#d9534f",
                    },
                  }}
                  variant="contained"
                  type="submit"
                  onClick={() => {
                    search();
                  }}
                >
                  <SearchIcon color="white" />
                  Ara
                </Button>
              </Grid>
              <Grid
                item
                xs={3}
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: 1,
                  alignItems: "center",
                }}
              >
                {" "}
                <AddWorkButtonWithModal
                  taxpayerList={taxpayerList}
                  workerList={workerList}
                  onSave={handleSaveWork}
                  workTypeOptions={workTypeOptions}
                  workStatusOptions={workStatusOptions}
                />
                <Button
                  className="custom-button"
                  variant="contained"
                  startIcon={<PersonAddIcon />} // İkonu ekledik
                  sx={{
                    textTransform: "none",
                    whiteSpace: "nowrap",
                    backgroundColor: "#FF9800 !important", // Güzel bir yeşil renk
                    "&:hover": { backgroundColor: "#FB8C00 !important" }, // Hover efekti için koyu yeşil
                  }}
                  onClick={handleAddResponsible}
                >
                  Sorumlu Ekle
                </Button>
              </Grid>
            </Grid>
          </Grid>

          <Grid
            className="ag-theme-quartz"
            style={{
              flex: 1,
              minHeight: "70vh",
              maxHeight: "70vh",
              width: "100%",
              boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
              borderRadius: "10px", // İstediğiniz değeri buraya ekleyin
              overflow: "hidden", // Border-radius'in düzgün görünmesi için
            }}
          >
            <AgGridReact
              localeText={localeTextTr}
              rowSelection="multiple"
              rowData={rowData}
              onFirstDataRendered={onFirstDataRendered}
              // getRowHeight={getRowHeight}
              // rowHeight={100}
              columnDefs={columnDefs}
              onGridReady={onGridReady}
              loading={loading}
              enableRangeSelection={true}
              sideBar={gridSideBar}
              getRowStyle={(params) => {
                if (params.data.is_deleted === true) {
                  return { background: lighten(0.4, "red") };
                }
              }}
              copyHeadersToClipboard={false}
              defaultColDef={defaultColDef}
              masterDetail={true}
              detailCellRendererParams={detailCellRendererParams}
              suppressRowDeselection={true}
              rowMultiSelectWithClick={true}
            />
          </Grid>
          <NoteModal
            isOpen={isModalOpen}
            onClose={closeModal}
            note={selectedNote}
            taxpayerList={taxpayerList}
            workerList={workerList}
            search={search}
            workTypeOptions={workTypeOptions}
            workStatusOptions={workStatusOptions}
          />
          <Grid
            item
            xs={12}
            sx={{
              justifyContent: "space-between",
              display: rowData?.length === 0 ? "none" : "flex",

              alignItems: "center",
            }}
          >
            <Grid
              item
              xs={12}
              sx={{
                justifyContent: "center",
                display: rowData?.length === 0 ? "none" : "flex",
                margin: "2% 0 2% 0",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <Pagination
                count={totalPage}
                showFirstButton
                showLastButton
                page={currentPage}
                sx={{
                  display: loading ? "none" : "block",
                }}
                onChange={(event, value) => {
                  search(undefined, value, pageSize);
                  setCurrentPage(value);
                  window.scrollTo({ top: 0, behavior: "smooth" });
                  localStorage.set("page", value);
                }}
              />
              <TextField
                select
                value={pageSize}
                size="small"
                sx={{
                  display: rowData?.length === 0 || loading ? "none" : "block",
                }}
                onChange={(e) => {
                  search(undefined, 1, e.target.value);
                  setCurrentPage(1);
                  localStorage.set("page", 1);
                  localStorage.set("pageSize", e.target.value);
                  setPageSize(e.target.value);
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
              >
                <MenuItem value={50}>50</MenuItem>
                <MenuItem value={100}>100</MenuItem>
                <MenuItem value={250}>250</MenuItem>
                <MenuItem value={500}>500</MenuItem>
              </TextField>
              <Typography
                sx={{
                  position: "absolute",
                  right: "3%",
                  display: !loading ? "block" : "none",
                }}
              >
                Toplam Kayıt : {totalCount}{" "}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default NotesPage;
